import { put, select, take, fork } from "redux-saga/effects";
import { delay } from "redux-saga";
import { selectUser } from "../util/selectors";
import { showDownloadAppDialog } from "../actions";
import { getMobileOS } from "../util";
import mixpanel from "../services/mixpanel";

const ALLOWED_AUTHENTICATED_ROUTES = ["/case/:slug", "/posts/:id", "/"];
const ALLOWED_UNAUTHENTICATED_ROUTES = ["/user/:username", "/profile/:id"];

function* handleDisplayDownloadAppDialog() {
  while (true) {
    yield take(["ROUTER_LOCATION_CHANGED", "SET_USER"]);

    if (getMobileOS() === null) {
      break;
    }

    const user = yield select(selectUser);
    const route = yield select(state => state.router.route);
    const isDownloadAppDialogDismissed = yield select(state => state.ui.isDownloadAppDialogDismissed);

    const showIfAuthenticated = !!user && ALLOWED_AUTHENTICATED_ROUTES.includes(route);
    const alwaysShow = ALLOWED_UNAUTHENTICATED_ROUTES.includes(route);

    if (!isDownloadAppDialogDismissed && (showIfAuthenticated || alwaysShow)) {
      yield delay(30000);
      yield put(showDownloadAppDialog());
      yield mixpanel.track("downloadapp.show");
      break;
    }
  }
}

export function* watchUiChanges() {
  yield fork(handleDisplayDownloadAppDialog);
}

export default watchUiChanges;



// WEBPACK FOOTER //
// ./src/sagas/UiSaga.js